<template>
  <div class="note-screen">
    <page-header v-if="this.$route.name === 'NoteScreen'" :title="$t('app.notes.title')"/>
    <div :class="this.$route.name == 'DetailedSiteScreen' ? 'row note-row mt-5 mb-20' : 'row mt-20 mb-20'">
      <div class="col-sm-12 text-right button-col">
        <base-button
          :title="$t('app.generals.createNew')"
          classNames="btn btn-orange rounded pull-right"
          @clicked="addNote"
        />
      </div>
    </div>
    <div class="panel-wrapper collapse in">
      <div :class="this.$route.name == 'DetailedSiteScreen' ? 'panel-heading note-heading detailed-heading' : 'panel-heading note-heading'">
          <div class="panel-title note-title txt-dark detailed-title">
            <span>{{$t('app.notes.date')}}</span>
            <span>{{$t('app.notes.title')}}</span>
            <span>{{$t('app.tables.global.actions')}}</span>
          </div>
        <div class="clearfix"></div>
      </div>
      <div v-if="notes && notes.notes && notes.notes.length > 0" :class="this.$route.name == 'DetailedSiteScreen' ? 'panel-body detailed-body' : 'panel-body'">
        <div class="streamline">
          <note-card
            v-for="(note,index) in notes.notes"
            :key="index"
            :note="note"
            :needActionButtons="true"
            @editNoteClicked="editNoteClicked"
            @deleteNoteClicked="deleteNoteClicked"
            />
        </div>
      </div>
      <div v-else-if="notes && notes.notes && notes.notes.length === 0">
        <div class="row mt-20 mb-10">
          <div class="col-sm-6">
            <span>{{$t('app.notes.noResult')}}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mt-20 mb-10">
          <div class="col-sm-6">
            <span>{{$t('app.notes.loading')}}</span>
          </div>
        </div>
      </div>
      <paginator-component
        v-if="notes && notes.notes && notes.notes.length > 0"
        :totalPages="totalPages"
        :currentPageIndex="currentPageIndex"
        @itemSelected="itemSelected"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import BaseButton from '@/components/shared/buttons/BaseButton';
import FormInput from '@/components/shared/inputs/FormInput';
import PageHeader from '@/components/shared/layouts/PageHeader';
import Paginator from '@/components/shared/navigations/Paginator';
import NoteCard from './NoteCard';
import GenericForm from '@/components/shared/forms/GenericForm';


export default {
  name: 'NoteScreen',
  components: {
    'base-button': BaseButton,
    'form-input': FormInput,
    'page-header': PageHeader,
    'paginator-component': Paginator,
    'note-card': NoteCard,
  },
  props: {
  },
  data() {
    return {
      currentPageIndex: 1,
      newMessage: '',
      notes: [],
      selectedNote: null,
      fields: [
        {
          name: 'message',
          type: 'text-area',
          classes: 'col-md-12',
        },
      ],
      newNote: {
        message: undefined,
      },
      noteAttributes: [
        {
          name: 'message',
          type: 'text-area',
          classes: 'col-md-12',
        },
      ],
    };
  },
  created() {
    if (this.$route.name === 'NoteScreen') {
      this.fetchNotes({
        pageIndex: this.currentPageIndex,
        id: this.loggedInUser.id,
      }).then((response) => {
        this.notes = response;
      });
    } else {
      this.fetchNotes({
        pageIndex: this.currentPageIndex,
        id: this.loggedInUser.id,
        partnerId: this.loggedInUser.partner_id,
      }).then((response) => {
        this.notes = response;
      });
    }
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    totalPages() {
      return this.notes.total_pages || 0;
    },
  },
  methods: {
    ...mapActions({
      fetchNotes: 'users/fetchNotes',
      createNewNote: 'users/createNote',
      updateSelectedNote: 'users/updateNote',
      deleteNote: 'users/deleteNote',
      fetchNote: 'users/fetchNote',
    }),
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    addNote() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.notes.create_title'),
          fields: this.fields,
          model: this.newNote,
          submitTitle: this.$t('app.notes.buttons.save'),
          cancelTitle: this.$t('app.notes.buttons.cancel'),
          modelName: 'notes',
        },
        on: {
          submit: this.createNote,
          modalCanceled: this.resetNewNote,
        },
      });
    },
    createNote(newNote) {
      if (newNote.message.length > 255) {
        this.$swal
          .fire({
            html: this.$t('app.notes.lengthError'),
            type: 'error',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false,
          });
        this.$eventBus.stopLoading();
      } else {
        if (this.$route.name !== 'NoteScreen') {
          newNote.partner_id = this.loggedInUser.partner_id;
        }
        this.createNewNote({ id: this.loggedInUser.id, params: newNote }).then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.notes.success.create'),
            notificationType: 'success',
          });
          this.fetchNotes({
            pageIndex: this.currentPageIndex,
            id: this.loggedInUser.id,
            partnerId: this.loggedInUser.partner_id,
          }).then((response) => {
            this.notes = response;
            this.$eventBus.hideModal();
            this.resetNewNote();
          }).catch((error) => {
            this.$eventBus.stopLoading();
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
        }).catch((error) => {
          this.$eventBus.stopLoading();
          this.$swal
            .fire({
              html: error[0],
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
      }
    },
    resetNewNote() {
      Object.assign(this.$data.newNote, this.$options.data().newNote);
    },
    editNoteClicked(id) {
      this.editNote(id);
    },
    editNote(id) {
      this.fetchNote({ id: this.loggedInUser.id, noteId: id }).then((note) => {
        this.$eventBus.showModal({
          bind: {
            is: GenericForm,
            title: this.$t('app.notes.update_title'),
            fields: this.noteAttributes,
            model: note,
            submitTitle: this.$t('app.notes.buttons.save'),
            cancelTitle: this.$t('app.notes.buttons.cancel'),
            modelName: 'notes',
          },
          on: {
            submit: this.updateNote,
          },
        });
      });
    },
    updateNote(note) {
      if (note.message.length > 255) {
        this.$swal
          .fire({
            html: this.$t('app.notes.lengthError'),
            type: 'error',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false,
          });
        this.$eventBus.stopLoading();
      } else {
        this.updateSelectedNote({ id: this.loggedInUser.id, params: note })
          .then(() => {
            this.fetchNotes({
              pageIndex: this.currentPageIndex,
              id: this.loggedInUser.id,
              partnerId: this.loggedInUser.partner_id,
            }).then((response) => {
              this.notes = response;
            });
            this.$eventBus.hideModal();
          })
          .catch((error) => {
            this.$eventBus.stopLoading();
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      }
    },
    deleteNoteClicked(id) {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            this.deleteNote({ id: this.loggedInUser.id, noteId: id }).then(() => {
              this.fetchNotes({
                pageIndex: this.currentPageIndex,
                id: this.loggedInUser.id,
                partnerId: this.loggedInUser.partner_id,
              }).then((response) => {
                this.notes = response;
              });
            })
              .catch((error) => {
                this.$swal
                  .fire({
                    html: error[0],
                    type: 'error',
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                  });
              });
          }
        });
    },
  },
  watch: {
    currentPageIndex(newValue) {
      this.fetchNotes({
        pageIndex: newValue,
        id: this.loggedInUser.id,
        partnerId: this.loggedInUser.partner_id,
      }).then((response) => {
        this.notes = response;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.note-heading {
  background: white;
  border-bottom: 1px solid #eee !important;
}

.detailed-heading {
  margin-right: 10px;
}

.note-title {
  display: flex;
  justify-content: space-between;
}

/deep/ .sl-content {
  margin-left: 100px;
}

.panel-body {
  background: white;
  margin-bottom: 40px;
}

.detailed-body {
  margin-right: 30px;
  margin-left: 20px;
}

.note-row {
  margin: -5px;
}

.button-col {
  padding-right: 25px;
  border-bottom: 1px solid #eee;
}

/deep/ .rounded {
  border-radius: 4px;
}

/deep/ .sl-avatar {
  left: -18px !important;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/helpdesk/NoteScreen.vue